import { createFileRoute } from '@tanstack/react-router';

// The Notes layout route renders the list + reader and reads the `highlight`
// search param; this child only defines the /notes/read/$id URL so the reader
// opens scoped to Notes. Back from the reader returns to /notes, not Home.
export const Route = createFileRoute('/_app/notes/read/$id')({
  validateSearch: (search: Record<string, unknown>): { highlight?: string } => ({
    // Coerce to string: the highlight id can arrive as a number (JSON int from
    // the backend), and dropping non-strings here would strip ?highlight= and
    // lose the scroll target.
    highlight:
      search.highlight != null && search.highlight !== ''
        ? String(search.highlight)
        : undefined,
  }),
  component: () => null,
});
